import * as React from "react"
import styled from "@emotion/styled"
import { theme, rr } from "../../styles/styleGuide"
import Svg from "../../assets/mobile/svg/tools.inline.svg"
import desPic from "../../assets/mobile/images/toolsDesign.png"
import devPicMobile from "../../assets/mobile/images/toolsDevMobile.png"
import devPicTablet from "../../assets/mobile/images/toolsDevTablet.png"
import motionPic from "../../assets/mobile/images/toolsMotions.png"
import MobileDetect from "mobile-detect"
var color = theme.color,
  font = theme.font
var isBrowser = typeof window !== "undefined",
  isTablet: boolean
if (isBrowser) {
  var userAgent = window.navigator.userAgent
  var md = new MobileDetect(userAgent)
  isTablet = md.tablet() != null
}

function Tools() {
  return (
    <Container id="tools">
      <Clip className="clip">
        <SlidesContainer className="slides-container">
          <Canvas />
          <SlidesHolder className="slides-holder">
            <Design />
            <Image image={desPic} />
            <Development />
            <ResponsiveImage />
            <Motion />
            <Image image={motionPic} />
          </SlidesHolder>
        </SlidesContainer>
        <Border />
      </Clip>
      <Title />
    </Container>
  )
}
const Container = styled.div`
  position: absolute;
  bottom: 0;
  width: 100vw;
  ${rr("height", "vh", 91.4)}
  overflow: hidden;
`
const Border = styled.div`
  position: absolute;
  pointer-events: none;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  ${rr("border", ` solid ${color.tools.primary}`, "2.4vw", "2.4vw", "2.1vw")}
  box-sizing: border-box;
`
const Clip = styled.div`
  height: 100%;
  width: 100%;
  clip-path: inset(0% 0% 0% 0%);
`
const Title = () => {
  const Text = styled.div`
    #tools-title-svg {
      position: absolute;
      top: 52%;
      left: 50%;
      transform: translate(-50%, -50%);
      height: 80%;
      .cls-1 {
        fill: ${color.tools.primary};
      }

      .cls-2 {
        ${rr("stroke-width", "vw", 0.5, 0.6, 0.3)}
        stroke: ${color.tools.background.design};
        fill: none;
      }

      .cls-3 {
        fill: ${color.tools.background.design};
      }
    }
  `
  const Border = styled.div`
    position: absolute;
    box-sizing: border-box;
    width: 100vw;
    height: 12%;
    top: 0;
    left: 0;
    /* border: solid ${color.skills.design.primary} 2vw; */
    background-color: ${color.tools.primary};
  `

  return (
    <Border className="section-title">
      <Text>
        <Svg />
      </Text>
    </Border>
  )
}
interface image {
  image: string
  imageTablet?: string
}
const Image: React.FC<image> = ({ image }) => {
  const Image = () => {
    const Image = styled.img`
      display: block;
      ${rr("width", "vw", 75, 70, 60)}
      /* ${rr("margin-top", "vh", 20)} */
      padding: 0.7em 0.2em;
      background-color: ${color.tools.background.design};
    `
    return <Image src={image} className="slide-background" />
  }
  const Holder = styled.div`
    position: relative;
    ${rr("height", "vh", 80)}
    /* height: 100vh; */
    width: 100vw;
    /* ${rr("margin-bottom", "vh", 20)} */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .slide-background {
      background-color: ${color.tools.background.design};
    }
  `
  return (
    <Holder>
      <Image />
    </Holder>
  )
}
const ResponsiveImage = () => {
  const Mobile = () => {
    const Image = styled.img`
      display: block;
      ${rr("width", "vw", 75, 70, 60)}
      padding: 0.7em 0.2em;
      background-color: ${color.tools.background.design};
    `
    return <Image src={devPicMobile} className="slide-background" />
  }
  const Tablet = () => {
    const Image = styled.img`
      display: block;
      ${rr("width", "vw", 80)}
      padding: 0.7em 0.2em;
      background-color: ${color.tools.background.design};
    `
    return <Image src={devPicTablet} className="slide-background" />
  }
  const Holder = styled.div`
    position: relative;
    ${rr("height", "vh", 80)}
    width: 100vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .slide-background {
      background-color: ${color.tools.background.design};
    }
  `
  return (
    <Holder>
      {isBrowser && !isTablet && <Mobile />}
      {isBrowser && isTablet && <Tablet />}
    </Holder>
  )
}

const Development = () => {
  const D = styled.span`
    font-size: 10em;
    color: ${color.white};
    ${font.title}
  `
  const Row = styled.span`
    display: block;
    -webkit-text-stroke: ${color.white};
    -webkit-text-stroke-width: 0.02em;
    font-size: 2em;
    ${font.title}
  `
  const RowsHolder = styled.div`
    margin-top: -3em;
    margin-bottom: -3em;
    margin-right: 0.3em;
    line-height: 1;
  `
  const Holder = styled.div`
    font-size: 13vw;
    transform: translateX(-4%);
    ${rr("height", "vh", 80)}
    margin-bottom: -1em;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0;
    .titel {
      color: ${color.tools.background.design};
    }
  `
  return (
    <Holder>
      <D>D</D>
      <RowsHolder>
        <Row className="titel">eve</Row>
        <Row className="titel">lop</Row>
        <Row className="titel">ment</Row>
      </RowsHolder>
    </Holder>
  )
}
const Design = () => {
  const D = styled.span`
    font-size: 10em;
    color: ${color.white};
    ${font.title}
  `
  const Row = styled.span`
    display: block;
    -webkit-text-stroke: ${color.white};
    -webkit-text-stroke-width: 0.02em;
    /* color: transparent; */
    font-size: 3em;
    ${font.title}
  `
  const RowsHolder = styled.div`
    margin-top: -3em;
    margin-bottom: -3em;
    ${rr("margin-right", "em", 0.4, 0.4, 0)}
    line-height: 1;
  `
  const Holder = styled.div`
    ${rr("font-size", "vw", 14, 14, 14)}
    transform: translateX(-3.5%);
    ${rr("height", "vh", 80)}
    /* padding-top: 0.8em; */
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0;
    .titel {
      color: ${color.tools.background.design};
    }
  `
  return (
    <Holder>
      <D>D</D>
      <RowsHolder>
        <Row className="titel">es</Row>
        <Row className="titel">ign</Row>
      </RowsHolder>
    </Holder>
  )
}
const Motion = () => {
  const M = styled.span`
    font-size: 4.4em;
    color: ${color.white};
    ${font.title}
  `
  const G = styled.span`
    font-size: 5.3em;
    color: ${color.white};
    ${font.title}
  `
  const Row = styled.span`
    display: block;
    -webkit-text-stroke: ${color.white};
    -webkit-text-stroke-width: 0.02em;
    font-size: 2em;
    ${font.title}
  `
  const RowsHolder = styled.div`
    margin-top: -3em;
    margin-bottom: -3em;
    line-height: 0.76;
  `
  const Secction = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0;
    padding: 0;
    line-height: 0.71;
  `
  const Holder = styled.div`
    ${rr("font-size", "vw", 18, 17.7, 14.7)}
    transform: translateX(-2.5%);
    ${rr("height", "vh", 80)}
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    .titel {
      color: ${color.tools.background.design};
    }
  `
  return (
    <Holder>
      <Secction className="motion">
        <M>M</M>
        <RowsHolder>
          <Row className="titel">ot</Row>
          <Row className="titel">ion</Row>
        </RowsHolder>
      </Secction>
      <Secction>
        <G>G</G>
        <RowsHolder>
          <Row className="titel">rap</Row>
          <Row className="titel">hics</Row>
        </RowsHolder>
      </Secction>
    </Holder>
  )
}
const Canvas = () => {
  React.useEffect(() => {
    var canvas = document.querySelector(".back-dots") as HTMLCanvasElement,
      ctx = canvas.getContext("2d") as CanvasRenderingContext2D,
      width = window.innerWidth,
      height = window.innerHeight,
      aspect = width / height
    canvas.width = canvas.scrollWidth
    canvas.height = canvas.scrollHeight

    ctx.fillStyle = color.tools.primary
    ctx.strokeStyle = color.tools.background.motion
    // ctx.shadowBlur = 15
    // ctx.shadowColor = color.offWhite
    ctx.font = `${aspect * 25}px serif`
    for (let y = 0; y < aspect * 75; y++) {
      for (let x = 0; x < aspect * 50; x++) {
        // ctx.beginPath()
        // ctx.arc(x * 50, y * 50, 2, 0, Math.PI * 2)
        // ctx.closePath()
        ctx.save()
        ctx.translate(x * aspect * 50 + aspect * 30, y * aspect * 50 + aspect * 10)
        ctx.rotate(50 * (Math.PI / 180))
        ctx.fillText("+", 0, 0)
        // ctx.strokeText("+", 0, 0)
        // ctx.fill()
        // ctx.stroke()
        ctx.restore()
      }
    }
  }, [])
  const Canvas = styled.canvas`
    position: absolute;
    height: 100%;
    width: 100vw;
    opacity: 0.2;
  `
  return <Canvas className="back-dots" />
}
const SlidesHolder = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin: 0;
  padding: 0;
  left: 0;
  top: 0;
  width: 100vw;
  transform: translateY(0%);
`
const SlidesContainer = styled.div`
  position: absolute;
  width: 100vw;
  bottom: 1%;
  height: 87%;
  overflow: hidden;
  background-color: ${color.tools.background.design};
`

export default Tools
